var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 21.6667H17C16.7917 21.6667 16.6667 21.8333 16.6667 22V22.6667C16.6667 22.875 16.7917 23 17 23H20.3333C20.5 23 20.6667 22.875 20.6667 22.6667V22C20.6667 21.8333 20.5 21.6667 20.3333 21.6667ZM23.375 9.08333L19.875 5.625C19.5 5.25 19 5 18.5 5H9.95833C8.875 5.04167 8 5.91667 8 7.04167V24.375C8 25.4583 8.875 26.3333 9.95833 26.3333H21.9583C23.0833 26.3333 24 25.4583 24 24.375V10.5C24 10 23.75 9.45833 23.375 9.08333ZM18.625 7.16667L21.8333 10.375H18.625V7.16667ZM22 24.375H9.95833V7.04167H16.625V11.375C16.625 11.9167 17.0833 12.375 17.625 12.375H22V24.375ZM11.6667 9.66667H15C15.1667 9.66667 15.3333 9.54167 15.3333 9.33333V8.66667C15.3333 8.5 15.1667 8.33333 15 8.33333H11.6667C11.4583 8.33333 11.3333 8.5 11.3333 8.66667V9.33333C11.3333 9.54167 11.4583 9.66667 11.6667 9.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.8333H11.6667C11.4583 14.8333 11.3333 14.7083 11.3333 14.5V13.8333C11.3333 13.6667 11.4583 13.5 11.6667 13.5H15C15.1667 13.5 15.3333 13.6667 15.3333 13.8333V14.5C15.3333 14.7083 15.1667 14.8333 15 14.8333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 14.8333H14.2917C14.0833 14.8333 13.9583 14.7083 13.9583 14.5V13.8333C13.9583 13.6667 14.0833 13.5 14.2917 13.5H17.625C17.7917 13.5 17.9583 13.6667 17.9583 13.8333V14.5C17.9583 14.7083 17.7917 14.8333 17.625 14.8333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 14.8333H17C16.7917 14.8333 16.6667 14.7083 16.6667 14.5V13.8333C16.6667 13.6667 16.7917 13.5 17 13.5H20.3333C20.5 13.5 20.6667 13.6667 20.6667 13.8333V14.5C20.6667 14.7083 20.5 14.8333 20.3333 14.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedInvoice);
export default __webpack_public_path__ + "static/media/Selected Invoice.e26d0c3708ccf98db84f9b4fda6dc897.svg";
export { ForwardRef as ReactComponent };